// eg. to place somthing above the modal use ${zIndex.modal} + 1
// use ${zIndex.above} to locally (not sticky, fixed, modal) render something above other content

export const zIndex = {
  bottomlessPit: -9999,
  below: -1,
  default: 0,
  above: 1,
  dropdown: 100,
  fixed: 200, // eg. floating action button
  modal: 500,
  toast: 700,
};
